<style lang="scss" scoped>
.time-type-select{
    display: flex;
    align-items: center;
    .time-type-item{
        margin-right: 7px;
        width: 40px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 18px;
        cursor: pointer;
    }
    
    .time-type-item:last-child{
        margin-right: 0;
    }
    #active{
       background: rgba(175, 175, 175, 0.2)
    }
}
</style>

<template>
    <div class="time-type-select">
        <div class="time-type-item" :id="value=='day'?'active':''" @click="setTime('day')">时</div>
        <div class="time-type-item" :id="value=='month'?'active':''" @click="setTime('month')">日</div>
        <div class="time-type-item" :id="value=='year'?'active':''" @click="setTime('year')">月</div>
       
    </div>
</template>

<script>
export default {
    name:"time-type-select",
    props:{
        value:String
    },
    model:{
        prop:"value",
        event:'updateValue'
    },
    methods:{
        setTime(type){

            if(this.value==type){
                return
            }
            this.$emit("change",type)

            this.$emit("updateValue",type)
        }
    }
}
</script>